// import { REHYDRATE } from 'redux-persist/constants';
import { GET_BLOGS_FAILURE, GET_BLOGS_REQUEST, GET_BLOGS_SUCCESS } from '../actions';

const initialState = {
	data: [],
	isLoading: false,
};

const blogs = (state = initialState, action) => {
	switch (action.type) {
		case GET_BLOGS_SUCCESS:
			return {
				...state,
				isLoading: false,
				data: action.response,
			};
		case GET_BLOGS_REQUEST:
			return {
				...state,
				isLoading: true,
				data: [],
			};
		case GET_BLOGS_FAILURE:
			return {
				...state,
				isLoading: false,
			};
		default:
			return state;
	}
};

export default blogs;



// WEBPACK FOOTER //
// ./src/reducers/blogs.js